import { render, staticRenderFns } from "./GroupDescription.vue?vue&type=template&id=e205c7a6&scoped=true&"
import script from "./GroupDescription.vue?vue&type=script&lang=js&"
export * from "./GroupDescription.vue?vue&type=script&lang=js&"
import style0 from "./GroupDescription.vue?vue&type=style&index=0&id=e205c7a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e205c7a6",
  null
  
)

export default component.exports